<template>
	<v-header title="我的预约" headerLeftStatus="true" />
	<div class="sysMain">
		<div class="sysMainBody">
			<List size="small" class="suiteMain" style="padding-left: 10px;">
				<ListItem v-for="item in patientList"  @click="patientCheck(item)">
					<ListItemMeta :title="item.patientName" :description="item.patient" />
					<template #action>
						<li>
							<Badge :count="item.noQueue" style="margin-right: 10px;">
								未预约 &ensp;
							</Badge>
							<Badge :count="item.queue" style="margin-right: 10px;">
								已预约 &ensp;
							</Badge>
							<Badge :count="item.complete" style="margin-right: 10px;">
								已完成 &ensp;
							</Badge>
						</li>
					</template>
				</ListItem>
			</List>
			<Drawer :title="model.patientTitle" placement="bottom" :mask-closable="false" height="100%"
				v-model="view.showDrawerPatient">
				<Card style="width:100%;margin-bottom: 10px;" >
					<template #title>
						<Badge :count="patientNoQueueList.length">
							未预约 &ensp;
						</Badge>
					</template>
					<template #extra>
						<a href="#" @click.prevent="queue">
							<Icon type="ios-loop-strong"></Icon>
							预约
						</a>
					</template>
					<List size="small" class="suiteMain">
						<ListItem v-for=" item in patientNoQueueList">
							<ListItemMeta :title="item.departName" />
						</ListItem>
					</List>
				</Card>
				<Card style="width:100%;margin-bottom: 10px;" v-show="patientQueueList.length>0">
					<template #title>
						<Badge :count="patientQueueList.length">
							已预约 &ensp;
						</Badge>
					</template>
					<template #extra>
						<Checkbox :indeterminate="view.indeterminate" :model-value="view.checkAll"
							@click.prevent="handleCheckAll">全选</Checkbox>
						<a href="#" @click.prevent="queueCancel">
							<Icon type="ios-loop-strong"></Icon>
							取消预约
						</a>
					</template>
					<CheckboxGroup v-model="model.departQueuePool" v-for=" item in patientQueueList"
						@on-change="checkAllGroupChange">
						<Row>
							<Col flex="auto" style="padding-left: 5px;">
							<Checkbox :label="item.departQueuePool">{{item.departName}}
							</Checkbox>
							</Col>
							<Col flex="120px" style="padding-left: 5px;">
							{{converterEx.toDateTimeString(item.appointmentTime)}}</Col>
						</Row>
						<Divider size="small"  />
					</CheckboxGroup>
				</Card>
				<Card style="width:100%;margin-bottom: 10px;" v-show="patientCompleteList.length>0">
					<template #title>
						<Badge :count="patientCompleteList.length">
							已完成 &ensp;
						</Badge>
					</template>
					<List size="small" class="suiteMain">
						<ListItem v-for="item in patientCompleteList">
							<ListItemMeta :title="item.departName" />
						</ListItem>
					</List>
				</Card>
			</Drawer>
		</div>
		<div style="text-align:center" v-show="view.initComplete===true&&patientList.length===0">
			<Result type="warning" title="" desc="没有相关数据"></Result>
		</div>
	</div>
</template>

<script>
	import header from "@/components/header/index";
	import {
		sysPost
	} from '@/utils/api'
	export default {
		name: 'myyuyue',
		data() {
			return {
				view: {
					showDrawerPatient: false,
					indeterminate: true,
					checkAll: false,
					initComplete:false,
				},
				patientList: [],
				patientNoQueueList: [], //未预约
				patientQueueList: [], //已预约
				patientCompleteList: [], //已完成
				model: {
					patientTitle: "请选择",
					patient: "",
					patientName: "",
					departQueuePool: []
				},
			};
		},
		created() {
			this.model.patient = this.$route.query.Patient;
			this.patientSearch();
		},
		methods: {
			patientSearch() {
				var that = this;
				sysPost(that, {
					"url": 'Queue/PatientQueue',
					"data": {}
				}, function(result) {
					that.view.initComplete=true;
					that.patientList = result;
					if (!that.isNullOrEmptyEx(that.model.patient)) {
						var patient = that.model.patient;
						var item = that.patientList.find(function(p) {
							return p.Patient == patient
						});
						that.patientCheck(item);
					}
				})
			},
			patientCheck(item) {
				this.model.patientTitle = item.patientName + "/" + item.patient;
				this.model.patient = item.patient;
				this.model.patientName = item.patientName;
				this.view.showDrawerPatient = true;
				this.patientQueue(item.patient);
			},
			patientQueue(patient) {
				var that = this;
				sysPost(that, {
					"url": 'Queue/PatientQueueDetail',
					"data": {
						"Patient": patient
					}
				}, function(result) {
					that.patientNoQueueList = result.noList;
					that.patientQueueList = result.yesList;
					that.patientCompleteList = result.completeList;
				})
			},
			handleCheckAll() {
				if (this.view.indeterminate)this.view.checkAll = false;
				else this.view.checkAll = !this.view.checkAll;
				this.view.indeterminate = false;
				if (this.view.checkAll) this.model.departQueuePool = this.patientQueueList.map(p => p.departQueuePool);
				else this.model.departQueuePool = [];
			},
			checkAllGroupChange(data) {
				if (data.length === this.patientQueueList.length) {
					this.view.indeterminate = false;
					this.view.checkAll = true;
				} else if (data.length > 0) {
					this.view.indeterminate = true;
					this.view.checkAll = false;
				} else {
					this.view.indeterminate = false;
					this.view.checkAll = false;
				}
			},
			queueCancel() {
				if (this.model.departQueuePool.length == 0) {
					this.$Message.info("请选择，取消预约记录！");
					return;
				}
				var that = this;
				this.$Modal.confirm({
					title: '友情提示',
					content: '<p>您确认取消预约?</p>',
					onOk: () => {
						sysPost(that, {
							"url": 'Queue/QueueCancel',
							"data": {
								"DepartPoolIds": this.model.departQueuePool
							}
						}, function() {
							that.model.patient = "";
							that.patientSearch();
							that.view.showDrawerPatient = false;
							that.$Message.success('操作成功！');
						})
					}
				});
			},
			queue() {
				this.$router.push({
					path: '/yuyueDepart',
					query: {
						Patient: this.model.patient,
						PatientName: this.model.patientName
					}
				})
			},
		},
		components: {
			"v-header": header
		}
	}
</script>
